import { createStore, withProps } from '@ngneat/elf';
import { CreateReportAdditifRequest, DacDemandeGroup } from '@/types';
import { SelectOption } from '@/components/form-builder/form-builder.types';

export interface ReportsStateProps {
  reports: DacDemandeGroup[];
  loading: boolean;
  createRequest: CreateReportAdditifRequest;

  // Data for selections
  availableDacs: any[];

  // Selection objects for form stability
  dacSelected: SelectOption | undefined;

  // Touched flags for validation
  formSubmitted: boolean;
  dacTouched: boolean;
  dateReportTouched: boolean;
  motifReportTouched: boolean;
  sourceDemandeTouched: boolean;
}

export const reportsInitialState: ReportsStateProps = {
  reports: [],
  loading: false,
  createRequest: {
    dacId: null,
    dateReport: null,
    motifReport: null,
    sourceDemande: null,
  },
  availableDacs: [],
  dacSelected: undefined,
  formSubmitted: false,
  dacTouched: false,
  dateReportTouched: false,
  motifReportTouched: false,
  sourceDemandeTouched: false,
};

export const reportsStateStore = createStore(
  { name: 'reports-state' },
  withProps<ReportsStateProps>({
    ...reportsInitialState,
  })
);
